import {createFetchClient} from '../util/request/middleware'
import {camelCase as camelCaseObject} from 'change-case-object'

const client = createFetchClient('v1/banners')

function normalizeUrlPath(url){
	const mobileAppUrl = url
		.replace(/(mobile\\\/)/, '')
	return mobileAppUrl
}

/**
 * Fetches the current banners for the mobile app
 * @url http://developmentmybudgetapi.azurewebsites.net/swagger/ui/index#!/Banner/Banner_GetBanners
 * @returns {}
 */
export async function fetchBanners(){
	const response = await client.get()
	const appBanners = response
		.filter((item) => item.UrlPath.includes('mobile'))
		.map((item) => Object.assign({}, item, {UrlPath: normalizeUrlPath(item.UrlPath)}))
	return camelCaseObject(appBanners)
}



// WEBPACK FOOTER //
// ./node_modules/mb-app-common/lib/api/banners.js